"use client";
import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import Footer from "../MainWebsiteComponent/Footer/Footer";
import Banner from "../Banner/Banner";
import Session from "../Session/Session";
import TracksCards from "../Tracks/TracksCards";
import BottomCart from "../BottomCart/BottomCart";

import SupportUsSection from "../Support/SupportUsSection";
import Instructor from "../Instructor/Instructor";

import { useRouter } from "next/router";
import { apiRequest } from "../../utils/axiosInstance";
import Head from "next/head";
import { useCommon } from "../../app/context";
import DraggableDialog from "../../hooks/Dialog";
import CustomizedSnackbar from "../../hooks/Snackbar";
import SimpleBackdrop from "../Backdrop/SimpleBackdrop";
import FamilyDevelopment from "../FamilyDevelopment/FamilyDevelopment";
import AboutUs from "../AboutUs/AboutUs";
import Testimonials from "../Testimonials/Testimonials";
import TestimonialsGridView from "../TestimonialsGridView/TestimonialsGridView";
import Team from "../Team/Team";
import EmptyCourse from "../EmptyCourse/EmptyCourse";
import { getUserData } from "../../hooks/HelperFunctions";
import { useSelector } from "react-redux";
// import { useShoppingCart } from "../../contexts/CartContext";

function TeachingPage(props) {
  const { orgDetails, subdomain } = props;

  const {
    updateCart,
    setUpdateCart,
    openSignUpModel,
    enrollNowHandler,
    setOpenSignUpModel,
    showSnackbarMessage,
    setOpenBackdrop,
    openDialog,
    dialogTitle,
    dialogBody,
    handleCloseDialog,
    handleConfirmCloseDialog,
    showSnackbar,
    snackbarSeverity,
    snackbarMessage,
    handleSnackbarClose,
    openBackdrop,
    handleCloseBackdrop,
  } = useCommon();

  const activeCurrency = useSelector(
    (state) => state.currency.activeCurrency
  );



  const { orgData, orgOgImage, slug} = orgDetails;

  const [courses, setCourses] = useState([]);
  const [tracks, setTracks] = useState([]);
  const [teachingInfo, setTeachingInfo] = useState(null);
  const [orgInfo, setOrgInfo] = useState(null);
  const [testimonials, setTestimonials] = useState([]);
  const [featuredMembers, setFeaturedMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [canonicalUrl, setCanonicalUrl] = useState("");


  useEffect(() => {
    if (!subdomain) return;

    setOpenBackdrop(true);
    setLoading(true);

    let userData = getUserData()
    let trackCardsUrl = `/getTrackCards?subdomain=${subdomain}`;
    if (userData && userData?.id) {
      trackCardsUrl += `&userId=${userData?.id}`;
    }

    // wrap each API call in a function
    const fetchCourses = () =>
      apiRequest(activeCurrency != "" ? `/getCourses?subdomain=${subdomain}&currency=${activeCurrency}` : `/getCourses?subdomain=${subdomain}`, "GET")
        .then((res) => setCourses(res?.body || []))
        .catch((err) => console.error("Courses error:", err));

    const fetchTracks = () =>
      apiRequest(trackCardsUrl, "GET")
        .then((res) => setTracks(res?.body || []))
        .catch((err) => console.error("Tracks error:", err));

    const fetchOrgInfo = () =>
      apiRequest(`/getTeachingPageHeaderInfo?subdomain=${subdomain}`, "GET")
        .then((res) => setOrgInfo(res?.data || null))
        .catch((err) => console.error("Org info error:", err));

    const fetchTeachingInfo = () =>
      apiRequest(`${process.env.NEXT_PUBLIC_EXTERNAL_TEACHING_SETTINGS_ENDPOINT}/taupdate/v1/public/getDetails/${subdomain}`, "GET")
        .then((res) => setTeachingInfo(res || null))
        .catch((err) => console.error("Teaching info error:", err));

    const fetchTestimonials = () =>
      apiRequest(`/getAllTestimonialsOfAnOrganization?subdomain=${subdomain}`, "GET")
        .then((res) => setTestimonials(res?.data || []))
        .catch((err) => console.error("Testimonials error:", err));

    const fetchMembers = () =>
      apiRequest(`/getAllFeaturedTeamMembersOfAnOrganization?subdomain=${subdomain}`, "GET")
        .then((res) => setFeaturedMembers(res?.data || []))
        .catch((err) => console.error("Members error:", err));

      // create an array of promises by calling the functions once
      const requests = [
        fetchCourses(),
        fetchTracks(),
        fetchTeachingInfo(),
        fetchOrgInfo(),
        fetchTestimonials(),
        fetchMembers(),
      ];
  
      Promise.allSettled(requests).finally(() => {
        setLoading(false);
        setOpenBackdrop(false);
      });

  }, [subdomain, activeCurrency]);

  

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCanonicalUrl(window.location.href);
    }
  }, []);

  return (
    <>
      <Head>
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
        {/* Organization Schema Markup */}
        {canonicalUrl && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Teacher",
                name: orgData?.orgFullName,
                description:
                  "Takbir is a secure, easy-to-use platform to learn Islam, Quran, Hadith, Fiqh, and more from trusted scholars—all in one place.",
                provider: {
                  "@type": "Teaching Account",
                  name: "Takbir",
                  url: canonicalUrl, // Use safe value
                },
                image: "https://www.mytakbir.com/images/courses/islam-course.jpg",
                url: canonicalUrl,
                offers: {
                  "@type": "Offer",
                  priceCurrency: "USD",
                  price: "Free and Paid",
                  availability: "https://schema.org/InStock",
                },
              }),
            }}
          />
        )}
      </Head>

      <div style={{ position: "fixed", zIndex: "999", left: "0", width: "100%", }}>
        <Header
          subdomain={subdomain}
          updateCart={updateCart}
          setUpdateCart={setUpdateCart}
          openSignUpModel={openSignUpModel}
          setOpenSignUpModel={setOpenSignUpModel}
        />
      </div>
      <div style={{ paddingTop: "78px" }}>
        <Banner subdomain={subdomain}
          orgData={orgData}
          orgInfo={orgInfo}
          teachingInfo={teachingInfo} />

        <Session
          data={courses}
          setUpdateCart={setUpdateCart}
          enrollNowHandler={enrollNowHandler}
          setOpenSignUpModel={setOpenSignUpModel}
        />
        <div style={{maxWidth : "1150px", margin: "0 auto", padding : "0px 24px"}}>
          <TracksCards
            tracks={tracks}
            setUpdateCart={setUpdateCart}
            showTitle={true}
          />
        </div>




        {/* {orgData?.setting?.ta_support_section == 1 && <SupportUsSection />}  */}
        <AboutUs teachingInfo={teachingInfo} />
        {testimonials?.length > 0 && <TestimonialsGridView testimonials={testimonials} />}



        {(teachingInfo && (teachingInfo?.teamMembers?.length > 0)) && (
          <Team 
          orgData={orgData} 
          featuredMembers={featuredMembers} 
          teachingInfo={teachingInfo}
          />
        )}

        {/* {orgData && orgData?.subDomain == "muna-family-development" && (
        <FamilyDevelopment />
      )} */}

      </div>
      <Footer />

      {/* {cartItems?.length > 0 && (
            <BottomCart
              updateCart={updateCart}
              setOpenSignUpModel={setOpenSignUpModel}
            />
          )} */}

      <DraggableDialog
        openDialog={openDialog}
        title={dialogTitle}
        titlePadding="10px 0px"
        body={dialogBody}
        actionButtonMargin="0px"
        actionButton="Yes, Enroll Me!"
        handleCloseDialog={handleCloseDialog}
        handleConfirmCloseDialog={handleConfirmCloseDialog}
        // width="500px"
        width="100%"
        padding="0px"
      //Height="200px"
      />

      <CustomizedSnackbar
        open={showSnackbar}
        severity={snackbarSeverity}
        message={snackbarMessage}
        handleClose={handleSnackbarClose}
      />

      <SimpleBackdrop open={openBackdrop} handleClose={handleCloseBackdrop} />
    </>
  );
}

export default TeachingPage;
